package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.shapes.Circle
import com.varabyte.kobweb.silk.theme.shapes.clip
import org.jetbrains.compose.web.css.px

val TestimonialImageStyle = CssStyle {
    base {
        Modifier
            .size(120.px)
            .clip(Circle())
            .objectFit(ObjectFit.Cover)
            .styleModifier {
                property("object-position", "50% 62%")
            }
    }
}
val TestimonialSectionStyle = CssStyle {
    base          { Modifier.padding(top = 30.px, bottom = 40.px) }
    Breakpoint.MD { Modifier.padding(top = 30.px, bottom = 60.px) }
}

val TestimonialTitleStyle = CssStyle {
    base          { Modifier.fontSize(24.px).margin(bottom = 20.px).padding(leftRight = 16.px) }
    Breakpoint.MD { Modifier.fontSize(40.px).margin(bottom = 60.px).padding(leftRight = 0.px) }
}